import { ConfigViewerEnvService } from '@aipb/gulliver/config-viewer/env';
import { BaseRouting } from '@aipb/gulliver/routing';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigViewerRouting extends BaseRouting {
  static APP_ROUTE = 'config-viewer';
  static configPath = ':configId';
  static detailPath = 'detail';
  static detailNamePath = ':name';
  static detailIdPath = ':id';

  private _detailDefault: string[] = [
    ConfigViewerRouting.detailPath,
    ConfigViewerRouting.detailNamePath,
    ConfigViewerRouting.detailIdPath
  ];

  constructor(configViewerEnv: ConfigViewerEnvService) {
    super(['/' + ConfigViewerRouting.APP_ROUTE, ConfigViewerRouting.configPath], configViewerEnv);
  }

  public detailDefault(name: string, id: string | null = 'default', configId: string = this.getConfigId()): void {
    this.nav(this._detailDefault, {
      configId,
      name,
      id
    });
  }

  public detailDefaultRouteUrl(
    name: string,
    id: string | null = 'default',
    configId: string = this.getConfigId()
  ): string {
    return this.routeUrl(this._detailDefault, {
      configId,
      name,
      id
    });
  }
}
